import { lazy } from 'react';
import AuthRoles from '@/app/auth/authRoles';

const OrderDetailsPage = lazy(() => import('./OrderDetailsPage'));

const ClientDetailsConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: AuthRoles.Orders,
  routes: [
    {
      path: 'orders/:id',
      element: <OrderDetailsPage />,
      children: [
        {
          path: ':overview',
          element: <OrderDetailsPage />,
        },
        {
          path: ':quotes',
          element: <OrderDetailsPage />,
        },
        {
          path: ':subscriptions',
          element: <OrderDetailsPage />,
        },
        {
          path: ':tickets',
          element: <OrderDetailsPage />,
        },
      ],
    },
  ],
};

export default ClientDetailsConfig;
